function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	var domain = location.hostname; // Get the website's domain (e.g., 'example.com')
	var path = "/";

	document.cookie = cname + "=" + cvalue + "; " + expires + "; domain=" + domain + "; path=" + path;
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}


document.addEventListener("DOMContentLoaded", function () {
	// Smooth scroll for anchor links
	document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(anchor => {
		anchor.addEventListener("click", function (e) {
			const targetId = this.hash.slice(1);
			const target = document.getElementById(targetId);
			if (target) {
				e.preventDefault();
				const offset = target.getBoundingClientRect().top + window.pageYOffset - 90;
				window.scrollTo({ top: offset, behavior: "smooth" });
			}
		});
	});

	// Handle scroll on load if URL has a hash
	if (window.location.hash) {
		window.addEventListener("load", function () {
			const targetId = window.location.hash.slice(1);
			const target = document.getElementById(targetId);
			if (target) {
				const offset = target.getBoundingClientRect().top + window.pageYOffset - 120;
				window.scrollTo({ top: offset, behavior: "smooth" });
			}
		});
	}
});

jQuery(function ($) {
    $(document).ready(function () {
        $('.faq-toggle .toggle-title').click(function () {
            $(this).toggleClass('opened');
            $(this).next().slideToggle();
        });
    });
});

$('.site-header-cart-button').click(function (e) {
    e.preventDefault();
    update_cart();
});

$('#cart_overlay, #close-cart-drawer').click(function (e) {
    console.log('clicked');
    e.preventDefault();
    $('#cart_overlay, #cart_drawer').removeClass('open');
});


/*Shipping protection */



let
  cart_currency = getCookie("cart_currency"),
  exchange_data = getCookie("exchange_data"),
  exchange_rate = 1;

exchange_data = exchange_data.split(':');

if ( exchange_data != '' ) {
	exchange_currency = exchange_data[0]
	exchange_rate = exchange_data[1]
}

function load_new_cart(){
	fetch('/cart/?sections=static-cart')
	.then(response => response.text())
	.then(html => {
		//console.log(JSON.parse(html))

		parsedHTML = JSON.parse(html)
		//console.log('new cart:')

		var cart_section = 'static-cart'

		const parsedCart = parsedHTML[cart_section]

		var parser = new DOMParser();
		var cartHTML = parser.parseFromString(parsedCart, 'text/html');

		const cart_form = cartHTML.querySelector('form');

		document.getElementById("cart-drawer-contents").innerHTML = "";
		document.getElementById("cart-drawer-contents").appendChild(cart_form);

		$(document).trigger('cart:rerendered');

		$('#cart_overlay, #cart_drawer').addClass('open');

		//const cart_total_price = cart_form.querySelector('.cart-total_price').dataset.total_price;

		const
			progress_header = cart_form.querySelector('.goal-progress-header'),
			progress_bar = cart_form.querySelector('.bar'),
			progress_1 = cart_form.querySelector('.goal-1'),
			progress_2 = cart_form.querySelector('.goal-2'),
			progress_3 = cart_form.querySelector('.goal-3'),
			progress_4 = cart_form.querySelector('.goal-4'),
			gift_type_1 = progress_header.getAttribute('gift_type_1'),
			gift_type_2 = progress_header.getAttribute('gift_type_2'),
			gift_type_3 = progress_header.getAttribute('gift_type_3'),
			gift_type_4 = progress_header.getAttribute('gift_type_4'),
			gift_1_title = progress_header.getAttribute('gift_1_title'),
			gift_1_message = progress_header.getAttribute('gift_1_message'),
			gift_2_title = progress_header.getAttribute('gift_2_title'),
			gift_2_message = progress_header.getAttribute('gift_2_message'),
			gift_3_title = progress_header.getAttribute('gift_3_title'),
			gift_3_message = progress_header.getAttribute('gift_3_message'),
			gift_4_title = progress_header.getAttribute('gift_4_title'),
			gift_4_message = progress_header.getAttribute('gift_4_message');

		let
			cart_price =  parseInt(progress_header.getAttribute('cart_price')),
			cart_total_price = parseInt(progress_header.getAttribute('cart_total_price')),
			threshold_in_cents_1 = parseInt(progress_header.getAttribute('threshold_in_cents_1')),
			threshold_in_cents_2 = parseInt(progress_header.getAttribute('threshold_in_cents_2')),
			threshold_in_cents_3 = parseInt(progress_header.getAttribute('threshold_in_cents_3')),
			threshold_in_cents_4 = parseInt(progress_header.getAttribute('threshold_in_cents_4')),
			triggered_goal_1 = false,
			triggered_goal_2 = false,
			triggered_goal_3 = false,
			triggered_goal_4 = false,
			next_goal = '',
			goal_prefix = 'a FREE ';

		let rate = 1

		if ( cart_currency != 'AUD' ) {
			if ( gift_type_1 == 'product') {
				threshold_in_cents_1 = threshold_in_cents_1 * exchange_rate;
			}
			if ( gift_type_2 == 'product') {
				threshold_in_cents_2 = threshold_in_cents_2 * exchange_rate;
			}
			threshold_in_cents_3 = threshold_in_cents_3 * exchange_rate;
			threshold_in_cents_4 = threshold_in_cents_4 * exchange_rate;
		}

		if ( cart_price >= threshold_in_cents_1 && threshold_in_cents_1 != 0 ) {
			triggered_goal_1 = true
		}
		if ( cart_price >= threshold_in_cents_2 && threshold_in_cents_2 != 0 ) {
			triggered_goal_2 = true
		}
		if ( cart_price >= threshold_in_cents_3 && threshold_in_cents_3 != 0 ) {
			triggered_goal_3 = true
		}
		if ( cart_price >= threshold_in_cents_4 && threshold_in_cents_4 != 0 ) {
			triggered_goal_4 = true
		}

		//Goal progress message2
		if (triggered_goal_3) {
			next_threshold = threshold_in_cents_4;
			if (gift_type_4 === 'message') {
				goal_prefix = '';
				next_goal = gift_4_message;
			} else {
				next_goal = gift_4_title;
			}
		} else if (triggered_goal_2) {
			next_threshold = threshold_in_cents_3;
			if (gift_type_3 === 'message') {
				goal_prefix = '';
				next_goal = gift_3_message;
			} else {
				next_goal = gift_3_title;
			}
		} else if (triggered_goal_1) {
			next_threshold = threshold_in_cents_2;
			if (gift_type_2 === 'message') {
				goal_prefix = '';
				next_goal = gift_2_message;
			} else {
				next_goal = gift_2_title;
			}
		} else {
			if (gift_type_1 === 'message') {
				goal_prefix = '';
				next_goal = gift_1_message;
			} else {
				next_goal = gift_1_title;
			}
			next_threshold = threshold_in_cents_1;
		}

		//console.log( cart_price )
		//console.log( next_threshold+' / '+rate)
		//next_threshold = next_threshold * exchange_rate;
		//console.log( next_threshold)

		const paragraph = document.createElement('p');
		if (triggered_goal_3) {
			paragraph.innerHTML = 'Congrats, you have unlocked all free gifts!';
		} else if (next_goal === '' && gift_type_3 === 'message' && gift_3_message != '') {
			paragraph.innerHTML = 'Congrats, you have unlocked <strong>'+gift_3_message+'</strong>';
		} else if (next_goal === '' && gift_type_2 === 'message' && gift_2_message != '') {
			paragraph.innerHTML = 'Congrats, you have unlocked <strong>'+gift_2_message+'</strong>';
		} else if (next_goal === '' && gift_type_1 === 'message') {
			paragraph.innerHTML = 'Congrats, you have unlocked <strong>'+gift_1_message+'</strong>';
		} else if (next_goal !== '') {
			next_value = (next_threshold - cart_price) / 100.00;
			//console.log( next_value)
			paragraph.innerHTML = `You are <b>$<span data-money-convertible>${ next_value.toFixed(2) }</span></b> away from ${goal_prefix} <b>${next_goal.split(' - ')[0]}</b>`;
		}

		progress_header.appendChild(paragraph);

		//Goal progress bar
		let goal1D = threshold_in_cents_1 * 1.00;
		let goal2D = threshold_in_cents_2 * 1.00;
		let goal3D = threshold_in_cents_3 * 1.00;
		let goal4D = threshold_in_cents_4 * 1.00;

		let maxGoal = goal1D;

		if (gift_4_title !== '' || (gift_type_4 === 'message' && gift_4_message !== '')) {
			maxGoal = goal4D;
		} else if  (gift_3_title !== '' || (gift_type_3 === 'message' && gift_3_message !== '')) {
			maxGoal = goal3D;
		} else if (gift_2_title !== '' || (gift_type_2 === 'message' && gift_2_message !== '')) {
			maxGoal = goal2D;
		}

		let goalPercent = 10000.00 / maxGoal;
		let goalTotal = cart_price / 100;
		goalPercent *= goalTotal;

		let goal1Percent = goal1D / maxGoal;
		goal1Percent *= 100;
		let goal2Percent = goal2D / maxGoal;
		goal2Percent *= 100;
		let goal3Percent = goal3D / maxGoal;
		goal3Percent *= 100;

		progress_bar.style.width = `${goalPercent}%`;
		if ( progress_1 ) {
			progress_1.style.right = `${100 - goal1Percent}%`;
		}
		if ( progress_2 ) {
			progress_2.style.right = `${100 - goal2Percent}%`;
		}
		if ( progress_3 ) {
			progress_3.style.right = `${100 - goal3Percent}%`;
		}

		//Show Free Gifts
		let free_gifts_to_add = [];
		const items = cart_form.querySelectorAll('.free-gift');

		for (var i = 0; i < items.length; i++) {
			const item = items.item(i);
			let threshold = parseInt(item.dataset.threshold);

			threshold = threshold * exchange_rate;

			if ( threshold <= cart_price && threshold != 0 ) {
				item.style.display = 'block';

				//Auto add free gifts to cart in single variants
				const item_select = item.querySelector('.auto-gwp');
				if (item_select) {
					free_gifts_to_add.push(item_select.value)
				}
			}
		}


		if ( getCookie("shipping_protection") != 'false' ) {
			//console.log('protect not removed');
			const ship_protect_item = document.querySelector('[data-cartitem_productid="'+ship_protect_id+'"]');
			if (ship_protect_item) {
				//console.log('protect in cart');
				//Protection already in cart, nothing to do
			} else {
				//console.log('add protect');
				//Add protection
				free_gifts_to_add.push(ship_protect_variant)
			}
		}
		//console.log( free_gifts_to_add )

		if (free_gifts_to_add.length) {
			Shopify.moveAlong = function() {
				if (free_gifts_to_add.length) {
					var request = free_gifts_to_add.shift();

					dataObj = {
						quantity: 1,
						id: request
					};
					//console.log(dataObj)

					fetch('/cart/add.js', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
								'Content-Type': 'application/json',
								'X-Requested-With': 'XMLHttpRequest'
						},
						body: JSON.stringify(dataObj)
					}).then((response) => {
						return new Promise((resolve) => response.json()
							.then((json) => resolve({
								status: response.status,
								ok: response.ok,
								json,
							})));
					}).then(({ status, json, ok }) => {
						switch (status) {
							case 400:
								console.log('no product available');
								Shopify.moveAlong();
								break;
							case 201:
								break;
							case 200:
								Shopify.moveAlong();
								break;
							case 500:
									break;
							default:
							//Any default tasks
						}
					})

				}
				else {
					// If the queue is empty, show confirmation popup
					console.log('completed - success')
					update_cart();
				}
			};
			Shopify.moveAlong();
		}

		//GWP Functionality
		for (let i = 1; i <= 3; i++) {
			gwp_triggers = parseInt(progress_header.getAttribute(`gwp_triggers_${i}`));
			gwp_items = parseInt(progress_header.getAttribute(`gwp_items_${i}`));
			gwp_id = parseInt(progress_header.getAttribute(`gwp_id_${i}`));
			gwp_key = progress_header.getAttribute(`gwp_key_${i}`);

			let gwp_item_qty = gwp_triggers - gwp_items

			//console.log(gwp_triggers);
			//console.log(gwp_items);

			/* for adding a single */
			if ( gwp_triggers > 0 && gwp_items == 0 && gwp_id ) {
				addProductToCart(gwp_id)
				break;
			}
			/* for adding multiple
			if ( gwp_triggers != gwp_items ) {
				if ( gwp_items == 0 ){
					addProductToCart(gwp_id)
					break;
				} else {
					if ( gwp_triggers > gwp_items) {
						updateCartLine(gwp_key,gwp_triggers)
						break;
					} else {
						updateCartLine(gwp_key,0)
						break;
					}
				}
			}*/
		}

	})
	.catch(e => {
		console.error(e);
	});
}

function updateCartLine(key,qty){
	let updates = {
		'id': key,
		'quantity': qty
	}

	//console.log(updates);

	fetch(window.Shopify.routes.root + 'cart/change.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(updates)
	})
	.then(response => {
		return response.json();
	})
	.then(cart_data => {
		update_cart();
	})
	.catch(error => {});
}


function update_cart() {
	//console.log('updating cart 2');

	if ( cart_currency != 'AUD' && cart_currency != 'CAD' && cart_currency != 'USD' ){
		if ( exchange_data == '' || exchange_currency != cart_currency ) {

			const local_price = parseInt(document.getElementById('exchange-rate').innerHTML);

			fetch('https://nakie.co/products/hammock-river-blue')
			.then(response => response.text())
			.then(html => {
				//console.log( html )
				var parser = new DOMParser();
				var pageHTML = parser.parseFromString(html, 'text/html');

				const au_price = parseInt(pageHTML.getElementById('exchange-rate').innerHTML);

				exchange_rate = local_price / au_price

				if ( cart_currency == 'USD' ) {
					exchange_rate = 0.68
				}

				setCookie('exchange_data', cart_currency+':'+exchange_rate), 0.1;
				load_new_cart();
			})
			.catch(e => {
				console.error(e);
			});
		} else {
      load_new_cart();
    }

		/*
		var myHeaders = new Headers();
		myHeaders.append("apikey", "lOsnayIzvLKn5KnpROXzFKRML2g1YKGI");

		var requestOptions = {
		method: 'GET',
		redirect: 'follow',
		headers: myHeaders
		};

		fetch("https://api.apilayer.com/exchangerates_data/latest?symbols=CAD,DKK,EUR,AED,JPY,NZD,NOK,SGD,ZAR,SEK,CHF,GBP,USD&base=AUD", requestOptions)
		.then(response => response.text())
		.then(text => {
		const json = JSON.parse(text);
		console.log(json);
		setCookie('exchange_rate', JSON.stringify(json.rates), 0.1);
		exchange_rate = json.rates;

		load_new_cart();
		})
		.catch(error => console.log('error', error));
		*/
	} else {
		//console.log( exchange_data )
		load_new_cart();
	}
}

$('#cart_drawer').on('click', '.add-gift', function() {

	const form = $(this).closest('.free-gift-form');
	const variant_id = form.find('select').val();
    const this_btn = $(this);

    this_btn.text('adding...')

    product_data = {
        quantity: 1,
        id: variant_id
    }

    fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(product_data)
    }).then((response) => {
        return new Promise((resolve) => response.json()
            .then((json) => resolve({
                status: response.status,
                ok: response.ok,
                json,
            })));
    }).then(({ status, json, ok }) => {
        switch (status) {
            case 400:
                console.log('no product available');
                break;
            case 201:
                break;
            case 200:
                console.log('product added');
                console.log(json);
                update_cart();
                this_btn.text('Add')

                break;
            case 500:
                break;
            default:
            //Any default tasks
        }
    })
});

$('#cart_drawer').on('click', '.variant-item', function (event) {

    let variants = document.querySelectorAll('.variant-item');

    variants.forEach(e => {
        e.classList.remove('active')
    })


    let target = event.target;
    let img = target.querySelector('img')
    if (img == null) {
        img = target;
        event.target.parentElement.classList.add('active')
    }
    else {
        event.target.classList.add('active')
    }

    //console.log('src', img.src)
    let main_img = document.querySelector('#cart-drawer-contents .upsell_image img');
    main_img.src = img.src;

    let new_target = event.target.parentElement;

    //origin price
    let origin = new_target.dataset.variantOrigin;
    if (origin == null) origin = event.target.dataset.variantOrigin;
    let main_original = document.querySelector('#cart-drawer-contents .new_upsell_item .price--compare-at');
    if (main_original != null) main_original.innerHTML = origin;


    //final price
    let final = new_target.dataset.variantPrice;
    if (final == null) final = event.target.dataset.variantPrice;
    let main_price = document.querySelector('#cart-drawer-contents .new_upsell_item .price--main');
    main_price.innerHTML = `Just ${final}`;


    //color name
    let color = new_target.dataset.variantTitle;
    if (color == null) color = event.target.dataset.variantTitle;
    let main_title = document.querySelector('#cart-drawer-contents .new_upsell_item .product-variant .value');
    main_title.innerHTML = color;


    // fetch(url).then(e => e.text()).then(html => {
    //   const div = document.createElement('div');
    //   div.innerHTML = html;
    //   document.querySelector('.product--price').innerHTML = div.querySelector('.product--price').innerHTML;
    //   let button = div.querySelector('.gallery-navigation--scroller button[data-gallery-selected="true"]');
    //   console.log('button', button);
    //   div.remove();
    // })

})


$('#cart_drawer').on('change', '.cart-item--info select', function () {
  const
		cart_item_qty = $(this).val(),
		cart_item_id = $(this).closest('.cart-item').data('cartitem-id');

	updateCartLine(cart_item_id,cart_item_qty)
});

$('#cart_drawer').on('click', '.cart-item--remove-link', function (e) {
  e.preventDefault();

  cart_item_id = $(this).closest('.cart-item').data('cartitem-id')

	//console.log( 'remove: '+ cart_item_id)
	updateCartLine(cart_item_id,0)

	/*
  $.ajax({
      url: '/cart/change?line='+cart_item_id+'&quantity=0',
      dataType: 'json',
      type: 'post',
      success: function (cart) {
        //console.log(cart)
        update_cart()
      },
      error: function (XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        console.log("Error: " + response);
      }
  }).done(function () {
      //any done functions?
  });*/
});

if ($(window).width() > '600') {
    $('#cart_page_form').addClass('horizontal')
}

$('body').on('click', '.new_atc_button', function (e) {

    e.preventDefault();
    //console.log('testing atc')

    //console.log('click hehe');

    this_btn = $(this)

    console.log('prev',this_btn.prev())
    //console.log('value',this_btn.prev().value)
    // let variant_active = document.querySelector('.variant-item.active');

    // if (variant_active == null) {
    //     variant_id = document.querySelector('.new_upsell  .upsell_atc').dataset.value;
    // }
    // else {
    //     variant_id = variant_active.dataset.variantId;
    // }

    let variant_id = this_btn.prev().val();

    //this_btn.text('Adding...')
    product_data = {
        quantity: 1,
        id: variant_id
    }

  //console.log()

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(product_data)
  }).then((response) => {
    return new Promise((resolve) => response.json()
    .then((json) => resolve({
      status: response.status,
      ok: response.ok,
      json,
    })));
  }).then(({ status, json, ok }) => {
    switch (status) {
      case 400:
          console.log('no product available');
          break;
      case 201:
          break;
      case 200:
          console.log('product added');
          console.log(json);
          update_cart();
          //this_btn.text('Add')

          break;
      case 500:
          break;
      default:
      //Any default tasks
    }
  })
});

/* removed Jan 2025
$('.product-selector-wrapper').on("click", ".option-value-label", function() {
	const form_options = $(this).closest('.form-options');
	form_options.find('.option-value').removeClass('option-selected');
	$(this).closest('.option-value').addClass('option-selected');
});

$('.product-form--regular').on("click", ".option-value-label", function() {
	const form_options = $(this).closest('.form-options');
	form_options.find('.option-value').removeClass('option-selected');
	$(this).closest('.option-value').addClass('option-selected');
});*/

function addProductToCart(select_variant,form_properties){
	const quantityEl = document.getElementById('product-quantity-input');
	let quantity_value = 1

	if (quantityEl) {
		quantity_value = quantityEl.value
	}

	let product_data = {
		quantity: quantity_value,
		id: select_variant
	}
	//console.log('atc form:')
	//console.log(form_properties);
	if (form_properties && form_properties != {} ) {
		product_data = {
			quantity: quantity_value,
			id: select_variant,
			properties: form_properties
		}
	}

	//include selling plans
	const sp = new URLSearchParams(window.location.search).get('selling_plan');
	if (sp && /^\d+$/.test(sp)) {
		// Shopify expects the numeric selling plan ID
		product_data.selling_plan = Number(sp);
	}

	console.log(product_data);

	fetch('/cart/add.js', {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
		},
		body: JSON.stringify(product_data)
	}).then((response) => {
		return new Promise((resolve) => response.json()
			.then((json) => resolve({
				status: response.status,
				ok: response.ok,
				json,
			})));
	}).then(({ status, json, ok }) => {
		switch (status) {
			case 400:
				console.log('no product available');
				break;
			case 201:
				break;
			case 200:
				document.documentElement.dispatchEvent(new CustomEvent('product:added', {
					bubbles: true,
					detail: {
						variant: select_variant,
						quantity: 1
					}
				}));
				update_cart();

				break;
			case 500:
					break;
			default:
			//Any default tasks
		}
	})
}

function addProductsToCart(selected_variants,button){
	console.log( selected_variants )
	Shopify.moveAlong = function() {
		if (selected_variants.length) {
			var data = selected_variants.shift();

			//console.log(dataObj)
			console.log('sending');

			fetch('/cart/add.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
				},
				body: JSON.stringify(data)
			}).then((response) => {
				return new Promise((resolve) => response.json()
					.then((json) => resolve({
						status: response.status,
						ok: response.ok,
						json,
					})));
			}).then(({ status, json, ok }) => {
				switch (status) {
					case 400:
						console.log('no product available');
						Shopify.moveAlong();
						break;
					case 201:
						break;
					case 200:
						Shopify.moveAlong();
						break;
					case 500:
							break;
					default:
					//Any default tasks
				}
			})

			/*
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: data,
				success: function(res){
					console.log("added: " + data);
					Shopify.moveAlong();
				},
				error: function(error){
					console.log(error);
					console.log("error: " + data);
					Shopify.moveAlong()
				}
			});*/
		}
		else {
			// If the queue is empty, show confirmation popup
			console.log('completed - success')
      update_cart();
			if (button) {
				button.prop("disabled", false).html('Add To Cart');
			}
		}
	};
	Shopify.moveAlong();
}


/* == Couples Combo Bundle == */

/* Update Button Status for preorder */

(() => {
	const BUNDLE_SELECTOR = '.option-values.type-bundle';
	const INPUT_SELECTOR  = '.option-value-input';
	const LABEL_SELECTOR  = '.option-value-label';

	const preorderText = document.querySelector('.preorder-message');

	function updateButtonText() {
		const btnEl = document.querySelector('#add-bundle .atc-button--text, #add-custom-bundle .atc-button--text');
		if (!btnEl) return;

		let anyPreorder = false;
		document.querySelectorAll(BUNDLE_SELECTOR).forEach(bundle => {
			const checked = bundle.querySelectorAll(`${INPUT_SELECTOR}:checked`);
			for (const input of checked) {
				const raw = (input.getAttribute('data-atc_btn') || '');
				const v = raw.trim().toLowerCase().replace(/\s+/g, ''); // normalize
				if (v === 'pre-order' || v === 'preorder') {
					anyPreorder = true;
					break;
				}
			}
		});

		if (anyPreorder) {
			btnEl.textContent = 'Pre-Order';
			preorderText.style.display = 'block';
		} else {
			btnEl.textContent = 'Add To Cart';
			preorderText.style.display = 'none';
		}
	}

	// Run on page load
	document.addEventListener('DOMContentLoaded', updateButtonText);

	// Respond to input changes inside bundles
	document.addEventListener('change', (e) => {
		if (e.target.matches(INPUT_SELECTOR) && e.target.closest(BUNDLE_SELECTOR)) {
			updateButtonText();
		}
	});
})();

/* Add To Cart */
$('#add-bundle').click(function(e){
	const button = $(this);
	let selected_variants = [];
	const sizeInput = document.querySelector('#product-quantity-select').selectedOptions[0];

	$('.form-options').each(function(index) {
		selected_variant = {
			quantity: sizeInput.value,
			id: $(this).find('.option-value-input:checked').data('id')
		}
		selected_variants.push(selected_variant)
	});

	/*Include any upsell items */
	const upsellInputs = document.querySelectorAll('.product-upsell input');
	upsellInputs.forEach(input => {
		if (input.checked) {
			const selected_variant = {
				quantity: input.dataset.qty,
				id: input.value
			}
			selected_variants.push(selected_variant);
		}
	});

	button.prop("disabled", true).html('Adding To Cart');

	addProductsToCart(selected_variants,button)
});

$('#add-custom-bundle').click(function(e){
	const button = $(this);
	let selected_variants = [];
	let bundle_price = 0;
	const sizeInput = document.querySelector('#product-quantity-select').selectedOptions[0];

	$('.form-options').each(function(index) {
		selected_option = $(this).find('.option-value-input:checked')
		selected_variant = {
			quantity: sizeInput.value,
			id: selected_option.data('id')
		}
		selected_variants.push(selected_variant)
		bundle_price = bundle_price + parseInt(selected_option.data('price'));
	});

	button.prop("disabled", true).html('Adding To Cart');

	addProductsToCart(selected_variants,button)

	bundle_price = (bundle_price * 0.8) / 100;
	//console.log( bundle_price );
	ga_event('add_bundle','Bundle Builder',bundle_price)
});

$('#add-single-product').click(function(e){
	e.preventDefault();
	let variant_id = '';

	$('.form-options').each(function(index) {
		variant_id = $(this).find('.option-value-input:checked').data('id')
	});

	console.log('adding: '+variant_id);

	addProductToCart(variant_id);
});

let AddToCartBtn = document.getElementById('AddToCart');
if (AddToCartBtn) {
	const AddToCartSticky = document.getElementById('sticky-add-to-cart');
	const position = AddToCartBtn.getBoundingClientRect();
	$(window).scroll(function(event){
		let st = $(this).scrollTop();
		if (st > position.top){
			AddToCartSticky.classList.add('stick')
		} else {
			AddToCartSticky.classList.remove('stick')
		}
	});
}


//Bundle Builder
const add_btn = document.querySelector(".js-add-more");
const selector_container = document.querySelector('.product-selector-wrapper')

//ADD MORE SELECTOR
add_btn?.addEventListener('click',()=>{

    const div = document.createElement("div");
    div.innerHTML = selector_container.innerHTML;
    const new_selector = div.querySelector('.product-selector');
    const product_number = selector_container.childElementCount + 1;

	let option_values = new_selector.querySelectorAll('.option-value');

	//console.log( option_values )
	for (const option of option_values) {

		const new_label = option.querySelector('.option-value-label')
		const new_input = option.querySelector('.option-value-input')
		const new_attr = new_label.getAttribute('for').replace('product-1','product-'+product_number);

		new_label.setAttribute('for',new_attr)
		new_input.setAttribute('id',new_attr)
		new_input.setAttribute('name','product-'+product_number)
	}

    new_selector.querySelector('.selector-heading .number').innerHTML = product_number;

    new_selector.querySelector('.control-products').classList.remove('swiper-1');
    new_selector.querySelector('.control-products').classList.add('swiper-'+product_number);

	new_selector.querySelector('.swiper-button-prev').classList.remove('swiper-prev-1');
    new_selector.querySelector('.swiper-button-prev').classList.add('swiper-prev-'+product_number);
    new_selector.querySelector('.swiper-button-next').classList.remove('swiper-next-1');
    new_selector.querySelector('.swiper-button-next').classList.add('swiper-next-'+product_number)

	selector_container.appendChild(new_selector)

	var swiper_new = new Swiper('.swiper-'+product_number, {
		spaceBetween: 3,
		slidesPerView: 3.5,
		breakpoints: {
			990: {
				slidesPerView: 4.5,
			}
		},
		pagination: {
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-next-'+product_number,
			prevEl: '.swiper-prev-'+product_number,
		},
		init: false
	});
	swiper_new.on('beforeInit', function () {
	    swiper_new.slideTo(1, 1, false)
	    swiper_new.slidePrev(1, false)
	})
	swiper_new.init()

	console.log( swiper3 )
})

function bundleChange(e){
	const bundleOptionsObjects = document.querySelectorAll('.cart-option-products');

	bundleOptionsObjects.forEach((object) => {
		object.style.display = 'none';
		object.classList.remove('selected');
	});

	const cartOptionProductElement = document.querySelector('.cart-option-products[data="'+e.target.value+'"]');
	cartOptionProductElement.style.display = 'block';
	cartOptionProductElement.classList.add('selected');

	const bundleOptionsPriceObjects = document.querySelectorAll('.cart-option-prices');
	bundleOptionsPriceObjects.forEach((object) => {
		object.style.display = 'none';
	});
	const cartOptionPriceElement = document.querySelector('.cart-option-prices[data="'+e.target.value+'"]');
	cartOptionPriceElement.style.display = 'flex';
	document.querySelector('#cart-upsell-percent').innerHTML = 100 - cartOptionPriceElement.getAttribute('data-percent')

	const selectedbundleOption = document.querySelector('.cart-option-products.selected');

	updateBundleImg(selectedbundleOption.querySelector('select option:checked').getAttribute('data-src'));

	$('#add-cart-upsell').prop("disabled", false);

}

function bundleImageChange(e){
	const selectedbundleOption = document.querySelector('.cart-option-products.selected');
	updateBundleImg(selectedbundleOption.querySelector('select option:checked').getAttribute('data-src'))
}

function updateBundleImg(src){
	const newImg = document.querySelector('.new-bundle-img').querySelector('img')
	newImg.style.opacity = '1';
	newImg.src = src;
	document.querySelector('.new-bundle-img').style.border = '1px solid #8fb8e0';
}

$('#cart_drawer').on("click", "#add-cart-upsell", function() {
	const button = $(this);
	button.prop("disabled", true).html('Adding Bundle');

	const FirstItemTitle = document.querySelector('.cart-item--content-title a');
	const BundleOptionsValue = document.querySelector('.cart-bundle-options').value ;

	/*
  let selected_variants = [];

	selected_variant = {
		quantity: 1,
		id: $('.cart-bundle-upsell').data('id')
	}
	selected_variants.push(selected_variant)
	*/

	const selected_upsell = document.querySelector('.cart-option-products.selected select');

	/*
	selected_variant = {
		quantity: 1,
		id: selected_upsell.value
	}
	selected_variants.push(selected_variant)
	*/

	let bundle_price = $('.cart-bundle-upsell').data('price');
	bundle_price = bundle_price + parseInt($(selected_upsell).find('option:selected').data('price'));
	bundle_price = (bundle_price * 0.8) / 100;
	ga_event('add_bundle','Bundle Upsell',bundle_price)

	addProductToCart(selected_upsell.value);

	/*
	addProductsToCart(selected_variants,button)

    fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
    }).then((response) => {
      return new Promise((resolve) => response.json()
      .then((json) => resolve({
        status: response.status,
        ok: response.ok,
        json,
      })));
    }).then(({ status, json, ok }) => {
			//console.log( status )
			//console.log( json )
			//console.log('success');
			addProductsToCart(selected_variants,button)
    })
		*/
})

function ga_event(event,action,value){
	gtag('event', event, {'action': action,'value': value});
}

// Select popup wrappers without the "no-close" class
const popupWrappers = document.querySelectorAll('.popup-wrapper:not(.no-close)');

function close_popup(wrapper){
	wrapper.style.display = 'none';

	// Pause any videos within the wrapper
	const videoElements = wrapper.querySelectorAll('video');
	videoElements.forEach(video => {
		if (!video.paused) {
			video.pause();
		}
	});
}

// Handle clicks on popup wrappers
popupWrappers.forEach(wrapper => {
	wrapper.addEventListener('click', (e) => {
		if (e.target === wrapper) {  // Check for direct click on the wrapper
			e.preventDefault();
			close_popup(wrapper)
		}
	});
});

// Handle clicks on close buttons
const closeButtons = document.querySelectorAll('.close-popup');
closeButtons.forEach(button => {
	button.addEventListener('click', (e) => {
		e.preventDefault();
		const wrapper = button.closest('.popup-wrapper');
		if (wrapper) {
			close_popup(wrapper)
		}
	});
});

function handleVideoClick() {
  const prodVidContainers = document.querySelectorAll('.video-preview-wrap');
  const videoPopupMedia = document.getElementById('video-popup-media');
  const videoPopup = document.getElementById('video-popup');

  prodVidContainers.forEach(container => {
    container.addEventListener('click', () => {
      const videoSrc = container.dataset.src;
      if (videoSrc) {
        videoPopupMedia.querySelector('source').src = videoSrc;

        videoPopup.style.display = 'block';
        videoPopup.addEventListener('transitionend', () => {
	        videoPopup.style.opacity = 1;
        });

        videoPopupMedia.load();  // Trigger loading of the new video
        videoPopupMedia.play();  // Optionally start playback
		videoPopupMedia.muted = false;

      }
    });
  });
}

// Call the function to set up event listeners
handleVideoClick();

const promoTabBtn = document.querySelector('.promo-tab-btn');

if (promoTabBtn) {
	if ( getCookie("promo_popup_seen") != 'true' ) {
		setTimeout(function () {
			console.log('not-seen')
			promoTabBtn.classList.add('active');
		}, 5000);
	}

	promoTabBtn.addEventListener('click', (e) => {
		e.preventDefault();

		promoTabBtn.classList.remove('active');

		setTimeout(function () {
			const promoTabPop = document.getElementById('promo-tab-popup');
			if (promoTabPop) {
				promoTabPop.style.display = 'block';
			}
		}, 300);

		setCookie('promo_popup_seen', 'true', 0.1);
	});
}

/*
const regionSelects = document.querySelectorAll('.region-select');
regionSelects.forEach(select => {
	select.addEventListener('change', () => {
		const selectedOption = select.options[select.selectedIndex];
		const url = selectedOption.dataset.url;
		if ( url != current_region ) {
			//console.log( 'https://www.nakie.' + url + pathname.split('?')[0] + '?region='+ url );
			setCookie('geo_location4', url, 365);
			window.top.location.href = 'https://www.nakie.' + url + pathname.split('?')[0] + '?region='+ url
		}
	});
});
*/


(function() {
	var form   = document.getElementById('MarketSwitcherForm');
	var select = document.getElementById('MarketSelect');
	var countryInput = document.getElementById('CountryCodeInput');
	if (!form || !select || !countryInput) return;

	// 1) Optional: if your <option> has data-country="AU" etc., we will use that first.
	//    (Recommend adding this to each option to avoid any guessing.)
	function fromDataAttr(optionEl) {
		var v = optionEl && optionEl.dataset ? optionEl.dataset.country : null;
		return v && /^[A-Z]{2}$/.test(v) ? v : null;
	}

	// 2) Fallback: known mapping from your market handles -> ISO country code
	//    (Based on your market_list handles)
	var HANDLE_TO_COUNTRY = {
		au: 'AU',
		ca: 'CA',
		de: 'DE',   // Europe/Germany both used "de" handle in your list
		nz: 'NZ',
		za: 'ZA',
		gb: 'GB',
		us: 'US',
		ch: 'CH',
		eu: 'AU'    // "International ($AUD)" — pick AU so currency stays AUD; adjust if needed
	};

	function fromHandle(handle) {
		return HANDLE_TO_COUNTRY[handle] || null;
	}

	// 3) Last-ditch: parse the visible label (e.g., "Australia ($AUD)") to an ISO
	var NAME_TO_COUNTRY = {
		'australia': 'AU',
		'canada': 'CA',
		'europe': 'DE',     // pick DE as a representative country for "Europe" option
		'germany': 'DE',
		'new zealand': 'NZ',
		'south africa': 'ZA',
		'united kingdom': 'GB',
		'uk': 'GB',
		'united states': 'US',
		'usa': 'US',
		'switzerland': 'CH',
		'international': 'AU' // using AU to match AUD; adjust if you change that option
	};

	function normalizeText(s) {
		return String(s || '')
			.toLowerCase()
			.replace(/\(.*?\)/g, '') // drop "($AUD)" etc.
			.replace(/[^a-z\s]/g, '')
			.trim();
	}

	function fromLabel(optionEl) {
		if (!optionEl) return null;
		var label = normalizeText(optionEl.textContent || optionEl.innerText || '');
		// try exact match first
		if (NAME_TO_COUNTRY[label]) return NAME_TO_COUNTRY[label];
		// try first two words (e.g., "united kingdom")
		var parts = label.split(/\s+/).slice(0, 2).join(' ');
		if (NAME_TO_COUNTRY[parts]) return NAME_TO_COUNTRY[parts];
		// try first word
		var first = (label.split(/\s+/)[0] || '');
		if (NAME_TO_COUNTRY[first]) return NAME_TO_COUNTRY[first];
		return null;
	}

	function resolveISO(optionEl) {
		// Priority: data-country -> handle map -> label map -> current value
		var dataIso = fromDataAttr(optionEl);
		if (dataIso) return dataIso;

		var handle = optionEl ? optionEl.value : '';
		var isoFromHandle = fromHandle(handle);
		if (isoFromHandle) return isoFromHandle;

		var isoFromLabel = fromLabel(optionEl);
		if (isoFromLabel) return isoFromLabel;

		// fallback to whatever is already in the hidden input
		var currentISO = (countryInput.value || '').toUpperCase();
		return /^[A-Z]{2}$/.test(currentISO) ? currentISO : '';
	}

	select.addEventListener('change', function() {
		var optionEl = select.options[select.selectedIndex];
		if (!optionEl) return;

		var iso = resolveISO(optionEl);
		if (!iso) return; // we couldn't resolve a country; do nothing

		countryInput.value = iso;
		form.submit();
	});
})();




const playButtons = document.querySelectorAll('.video-overlay');
const pauseButtons = document.querySelectorAll('.video-pause-button');

playButtons.forEach(button => {
	button.addEventListener('click', () => {
		const videoWrap = button.closest('.video-wrap');
		const video = videoWrap.querySelector('video');
		const videoPause = videoWrap.querySelector('.video-pause-button');

		if (video) {
			video.play();
		}
		button.style.display = 'none';
		videoPause.style.display = 'flex';
	});
});

pauseButtons.forEach(button => {
	button.addEventListener('click', () => {
		const videoWrap = button.closest('.video-wrap');
		const video = videoWrap.querySelector('video');
		const videoPlay = videoWrap.querySelector('.video-play-button');
		const videoOverlay = videoWrap.querySelector('.video-overlay');

		if (video) {
			video.pause();
		}
		button.style.display = 'none';
		videoOverlay.style.display = 'flex';
	});
});

function section_social_videos(videoSection){

	//console.log('video section')
	const videoPlayers = videoSection.querySelectorAll("video"); // Get all video elements
	let currentVideoIndex = videoPlayers.length;
	let videos_loaded = false

	function playNextVideo() {

		//console.log('playing:'+currentVideoIndex)

		currentVideoIndex++;

		//console.log('playing2:'+currentVideoIndex)


		if (currentVideoIndex >= videoPlayers.length) {
			currentVideoIndex = 0; // Loop back to the beginning
		}

		for (var i = 0; i < videoPlayers.length; i++) {
			videoPlayers[i].closest('li').classList.remove('active');
		}

		const current_video = videoPlayers[currentVideoIndex]

		for (var source in current_video.children) {
			const videoSource = current_video.children[source];
			if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				videoSource.src = videoSource.dataset.src;
			}
		}

		current_video.closest('li').classList.add('active');
		current_video.play();
	}

	for (var i = 0; i < videoPlayers.length; i++) {
		videoPlayers[i].addEventListener("ended", playNextVideo);
	}

	function loadVideos() {
		//console.log('loaidng:'+videos_loaded)
		if (videos_loaded == false) {
			videos_loaded = true;
			//Preload videos
			for (var i = 0; i < videoPlayers.length; i++) {
				const current_video = videoPlayers[i]

				for (var source in current_video.children) {
					const videoSource = current_video.children[source];
					if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
						videoSource.src = videoSource.dataset.src;
					}
				}
				current_video.load();
			}
		}
	}

	const scrollHandler = function() {
		if (videoSection) {
			const isInView = videoSection.getBoundingClientRect().top >= 0 &&
			videoSection.getBoundingClientRect().bottom <= window.innerHeight;

			if (isInView) {
				loadVideos();
				playNextVideo();

				window.removeEventListener('scroll', scrollHandler);
			}
		}
	}
	window.addEventListener('scroll', scrollHandler);
}

const videoSections = document.querySelectorAll(".autoplay-videos"); // Get all video sections

for (var i = 0; i < videoSections.length; i++) {
	section_social_videos(videoSections[i])
}


// Select the cart drawer contents element
const cartDrawerContents = document.getElementById('cart-drawer-contents');
if ( cartDrawerContents ){
	// Use event delegation to attach a change event listener
	cartDrawerContents.addEventListener('change', function(event) {
		// Check if the event target is the checkbox
		if (event.target.id === 'ship-protect-check') {
			if ( !event.target.checked) {
				// Checkbox is deselected, perform your desired action
				console.log("Ship protect checkbox deselected!");
				setCookie('shipping_protection', 'false', 1);
				const ship_protect_item = document.querySelector('[data-cartitem_productid="'+ship_protect_id+'"]');
				ship_protect_item.querySelector('.cart-item--remove-link').click();
			} else {
				addProductToCart(ship_protect_variant);
				console.log("Need to add Ship protect");
			}
		}
	});
}



const headerCustom = document.querySelector('.site-header-wrapper');
if (headerCustom){
	let
		prevScroll = 0,
		scroll_y_max = 100;

	function handleScroll() {
		if ( prevScroll == 0){
			scroll_y_max = 21;
		} else {
			scroll_y_max = 100;
		}
		prevScroll = window.scrollY;

		if (window.scrollY < 20) {
			headerCustom.classList.remove('sticky');
		}
		else if (window.scrollY > scroll_y_max) {
			headerCustom.classList.add('sticky');
		}
	}

	window.addEventListener('scroll', handleScroll);

	/* Custom Functionality to Open Menu */
	const menuButtonOpen = document.querySelector('.site-header-menu-button');
	const menuButtonClose = document.querySelector('.mobile-nav-close');
	const websiteBody = document.querySelector('body');
	const mobileNav = document.querySelector('.site-mobile-nav');
	const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');

	function openMobileMenu() {
		websiteBody.classList.add('scroll-lock');
		mobileNav.classList.add('animating');
		mobileNav.classList.add('animating-in');

		setTimeout(function () {
			mobileNav.classList.remove('animating');
			mobileNav.classList.remove('animating-in');
			mobileNav.classList.add('visible');
		}, 300);
	}

	function closeMobileMenu() {
		websiteBody.classList.remove('scroll-lock');
		mobileNav.classList.add('animating');
		mobileNav.classList.add('animating-out');

		setTimeout(function () {
			mobileNav.classList.remove('animating');
			mobileNav.classList.remove('animating-out');
			mobileNav.classList.remove('visible');
		}, 300);
	}

	if (menuButtonOpen){
		menuButtonOpen.addEventListener('click', openMobileMenu);
	}
	if (menuButtonClose){
		menuButtonClose.addEventListener('click', closeMobileMenu);
	}
	if (mobileNavOverlay){
		mobileNavOverlay.addEventListener('click', closeMobileMenu);
	}

	const mobileNavContent = document.querySelector('.mobile-nav-content');
	if (mobileNavContent){
		mobileNavContent.addEventListener('click', function(event) {
			console.log( event.target.classList )
			if (event.target.classList.contains('navmenu-button')) {
				const buttonElement = event.target;
				const prevLink = buttonElement.previousElementSibling;
				const parentLink = buttonElement.closest('.navmenu-item-parent');
				const subMenu = parentLink.querySelector('.navmenu-submenu');

				if (prevLink) {
					prevLink.classList.toggle('navmenu-link-parent-active');
				}
				if (subMenu) {
					subMenu.classList.toggle('visible');
				}
			}
		});
	}


	const navSearch = document.querySelector('.site-header-search-wrapper');
	const navSearchBtn = document.querySelector('.site-header-search-button');
	const liveSearch = document.querySelector('.live-search');
	const liveSearchBtn = document.querySelector('.live-search-button');
	const closeSearch = document.querySelector('.site-header-search-close');
	const closeSearchMobile = document.querySelector('.live-search-takeover-cancel');


	function OpenNavSearch() {
		navSearch.classList.add('show-search');
		liveSearch.classList.add('live-search--focused','live-search--active');
	}
	function CloseNavSearch() {
		navSearch.classList.remove('show-search');
		liveSearch.classList.remove('live-search--focused','live-search--active');
	}
	if (navSearchBtn){
		navSearchBtn.addEventListener('click', OpenNavSearch);
	}
	if (closeSearch){
		closeSearch.addEventListener('click', CloseNavSearch);
	}
	if (closeSearchMobile){
		closeSearchMobile.addEventListener('click', CloseNavSearch);
	}

	function search_results(query){

		fetch('https://nakie.co/search?q='+query+'&sections=static-search')
		.then(response => response.text())
		.then(html => {
			//console.log(JSON.parse(html))

			parsedHTML = JSON.parse(html)
			//console.log('new cart:')

			var search_section = 'static-search'

			const parsedSection = parsedHTML[search_section]

			var parser = new DOMParser();
			var sectionHTML = parser.parseFromString(parsedSection, 'text/html');

			const product_results = sectionHTML.querySelector('.productgrid--items');

			document.querySelector(".search-flydown").innerHTML = "";
			document.querySelector(".search-flydown").appendChild(product_results);

			liveSearchBtn.classList.remove('search-icon--processing');


		});
	}

	const liveSearchInput = document.querySelector('.live-search-form-field');
	let searchInputTimeout = null;

	if (liveSearchInput){
		liveSearchInput.addEventListener('input', function() {
			liveSearchBtn.classList.add('search-icon--processing');

			clearTimeout(searchInputTimeout);

			searchInputTimeout = setTimeout(() => {
				search_results(this.value)
			}, 1000);
		});
	}

	function searchMobileTakeover() {
		const liveSearchElement = document.querySelector('.live-search');

		if (liveSearchElement){
			if (window.innerWidth < 751) {
				liveSearchElement.classList.add('live-search--takeover');
			} else {
				liveSearchElement.classList.remove('live-search--takeover');
			}
		}
	}

	setTimeout(function () {
		searchMobileTakeover();
	}, 1000);

	window.addEventListener('resize', searchMobileTakeover);
}

/* Countdown timers */
function countdownTimer(target,targetDate){
	const countDownDate = new Date(targetDate).getTime();

	//Local timezone offset
	const LocalzoneOffset = new Date().getTimezoneOffset() * 60 * 1000;

	//AU Offset in Mins
	const AUoffset = 10 * 60
	const AUzoneOffset = AUoffset  * 60 * 1000;

	const timezoneOffset = AUzoneOffset + LocalzoneOffset;

	function calculateTime(){
		// Get today's date and time
		let now = new Date().getTime();

		//console.log( Math.floor((timezoneOffset % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) )
		now += timezoneOffset;

		// Find the distance between now and the count down date
		const distance = countDownDate - now;

		// Time calculations for days, hours, minutes and seconds
		let days = Math.floor(distance / (1000 * 60 * 60 * 24));
		let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		let seconds = Math.floor((distance % (1000 * 60)) / 1000);

		if (days < 10) { days = '0'+days }
		if (hours < 10) { hours = '0'+hours }
		if (minutes < 10) { minutes = '0'+minutes }
		if (seconds < 10) { seconds = '0'+seconds }

      	// If the count down is finished, hide
		if (distance < 0) {
		  clearInterval(cd_interval);
		  target.style.display = 'none'; // Hide directly
		} else {
		  target.classList.remove('loading');
		  target.innerHTML = `<span class="time-${days}">${days}</span><span>:</span><span>${hours}</span><span>:</span><span>${minutes}</span><span>:</span><span>${seconds}</span>`;
		}
	}

	calculateTime();

    // Update the count down every 1 second
    var cd_interval = setInterval(function() {
		calculateTime();
    }, 1000);
}

const countdownTimers = document.querySelectorAll('.countdown-timer');

countdownTimers.forEach(timerElement => {
	countdownTimer(timerElement,timerElement.dataset.date);
});

const swatchWrapper = document.querySelector('.swatch-wrapper');
if ( swatchWrapper ) {
	setTimeout(function () {
		swatchWrapper.classList.add('loaded');
	}, 1000);
}


const formFieldInputs = document.querySelectorAll('.form-field-input');

formFieldInputs.forEach(input => {
	input.addEventListener('input', function() {
		if (this.value.trim() !== "") {
			this.classList.add('form-field-filled');
		} else {
			this.classList.remove('form-field-filled');
		}
	});
});

// Helper function to check if the element is in the viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

function easeOutExpo(t) {
  return 1 - Math.pow(1 - t, 20); // Replace 5 with a higher number for stronger slow-down
}

function animateCounter(element, start, end, duration) {
  let startTime = null;

  function updateCounter(currentTime) {
    if (!startTime) startTime = currentTime;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1); // Linear progress (0 to 1)
    const easedProgress = easeOutExpo(progress); // Apply stronger easing

    const value = Math.floor(easedProgress * (end - start) + start); // Calculate the current value
    element.textContent = value.toLocaleString(); // Update the displayed number

    if (progress < 1) {
      requestAnimationFrame(updateCounter); // Continue animation
    } else {
      console.log("Animation complete"); // Debugging
    }
  }

  requestAnimationFrame(updateCounter);
}

// Scroll event listener
document.addEventListener("scroll", () => {
  const counters = document.querySelectorAll(".counter");
  counters.forEach((counter) => {
    if (isInViewport(counter) && !counter.classList.contains("counted")) {
    const start = parseInt(counter.getAttribute("data-start"), 10);
    const end = parseInt(counter.getAttribute("data-end"), 10);
    const duration = 20000;
    counter.classList.add("counted");
    animateCounter(counter, start, end, duration);
    }
  });
});

// Accordions

document.addEventListener('click', (e) => {
	const btn = e.target.closest('.accordion-btn');
	if (!btn) return;

	// panel is the immediate sibling per your markup
	const panel = btn.nextElementSibling;
	if (!panel || !panel.classList.contains('accordion-content')) return;

	const isOpen = btn.classList.toggle('active');

	// ARIA sync
	btn.setAttribute('aria-expanded', String(isOpen));
	panel.setAttribute('aria-hidden', String(!isOpen));
});


//SKIO Custom

//Skio Sales text:

document.addEventListener('DOMContentLoaded', () => {
	const target = document.querySelector('.skio-group-content');
	if (!target) return;
	if (target.nextElementSibling?.classList.contains('skio-benefits')) return; // prevent duplicate

	const html = `
	<ul class="skio-benefits" style="list-style:none; padding:0;">
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Each box plants 4 trees
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			FREE shipping on every order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Free Gift Every 3rd Order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Cancel anytime
		</li>
	</ul>`;
	target.insertAdjacentHTML('afterend', html);
});

document.addEventListener('DOMContentLoaded', () => {
	const qty = document.querySelector('.quantity-swatches');
	const qtyInput = document.getElementById('product-quantity-input');

	if (qty) {
		// Multi pack selector
		document.querySelectorAll('input[name="pack-size"]').forEach(radio => {
			radio.addEventListener('change', e => {
				qtyInput.value = e.target.value;
				discountValue = e.target.dataset.discount;

				const saveTxt = document.querySelector('.skio-save');
				saveTxt.innerHTML = `Save ${discountValue}%`
			});
		});



		const showQty = () => qty.classList.remove('is-closed');
		const hideQty = () => {
			qty.classList.add('is-closed');
			if (qtyInput) qtyInput.value = 1;
		};

		// Labels
		const oneTimeLabels = document.querySelectorAll('.skio-group-label[for*="skio-one-time"]');
		const otherLabels   = document.querySelectorAll('.skio-group-label[for]:not([for*="skio-one-time"])');

		// Clicks on labels
		oneTimeLabels.forEach(l => l.addEventListener('click', hideQty));
		otherLabels.forEach(l => l.addEventListener('click', showQty));
	}
});